export default (params) => ({
  trigger: {
    name: 'add_to_cart_page.select_energy_label_information',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'product_information_sheet',
          'energy_label_image',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'energy_label',
      },
    },
    nonInt: true,
  },
});
